/**
 * Extend SX with additional theme props
 *
 * @param sx original sx
 * @param value additional `sx` that can override the original
 * @returns augmented `sx`
 */
export default function extendSX(sx, value) {
  // We cannot spread `sx` directly because `SxProps` (typeof sx) can be an array.
  return [...(Array.isArray(value) ? value : [value]), ...(Array.isArray(sx) ? sx : [sx])];
}